interface Props {
	page: string
}

export const GlossaryEmptyState = ({ page }: React.PropsWithChildren<Props>) => (
	<p>Sorry, we dont know about any terms starting with the letter {page.toUpperCase()}</p>
)
